// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';
// @todo: Migrate to 'Slider' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Slide, toast} from 'react-toastify';

import * as S from './CodeSnippet.styles';

type CodeCopyButtonProps = {
  copyContent: string;
  analyticsEvent?: (data: any) => void;
  analyticsDefaultProperties?: Record<string, any>;
};

export const CodeCopyButton = ({
  copyContent,
  analyticsEvent,
  analyticsDefaultProperties,
}: CodeCopyButtonProps) => {
  const onCopyClick = useCallback(() => {
    // Ensure we always copy as plain text so escape sequences like \n
    // remain literal in the pasted content.
    copyToClipboard(copyContent, {format: 'text/plain'});
    toast('Copied to clipboard', {
      transition: Slide,
    });

    analyticsEvent?.({
      ...analyticsDefaultProperties,
      codeSnippet: copyContent,
    });
  }, [copyContent, analyticsEvent, analyticsDefaultProperties]);

  return (
    <S.CodeCopyButton onClick={onCopyClick}>
      <S.IconContainer>
        <Icon name="copy" /> Copy
      </S.IconContainer>
    </S.CodeCopyButton>
  );
};
